<div class="rc-block">
  @if (headerType !== HeaderType.NoHeader) {
    <div class="rc-block__header" [ngClass]="actionButtonVisible ? 'header--editing' : ''">
      <div class="rc-block__header-left">
        @switch (headerType) {
          @case (HeaderType.Index) {
            <span class="rc-block__header-indicator">{{ index }}</span>
          }
          @case (HeaderType.Icon) {
            @if (headerIconType) {
              <div class="rc-block__header-icon rc-block__header-icon--title rc-icon rc-icon--{{ headerIconType }} active"></div>
            }

            @if (headerIconName) {
              <app-icon [name]="headerIconName" class="rc-block__header-icon rc-block__header-icon--title"></app-icon>
            }
          }
        }
        <span class="rc-block__header-title rc-title-epsilon">{{ headerTitle }}</span>
      </div>
      <div class="rc-block__space" [ngClass]="actionButtonVisible ? 'space--editing' : ''"></div>
      <div class="rc-block__header-right">
        @if (actionButtonVisible && !hyperlink) {
          <rc-link
            [attr.data-qa]="'vs-account-page-block-' + headerTitle.toLowerCase() + '-button-action'"
            variant="secondary"
            size="large"
            (click)="didClickActionButton($event)"
          >
            @if (actionButtonIconType) {
              <span class="rc-block__header-icon rc-icon rc-icon--{{ actionButtonIconType }}"></span>
            }
            {{ actionButtonText }}
          </rc-link>
        }
        @if (hyperlink) {
          <app-hyperlink [href]="hyperlink.href" [icon]="hyperlink.icon">{{ hyperlink.label }}</app-hyperlink>
        }
        <div class="rc-block__header-action">
          <ng-content select="[topRight]"></ng-content>
        </div>
      </div>
    </div>
  }

  @if (!showLoader) {
    <div class="rc-block__body">
      <ng-content></ng-content>
    </div>
  }

  @if (showLoader) {
    <div class="rc-block__loader">
      <app-loader [transparent]="true" [withinContent]="true" [size]="rcLoaderSize"></app-loader>
    </div>
  }
</div>
